<script lang="ts">
  import { onMount } from 'svelte';
  import { AbTestService } from '@centerhealth/fe/abtest';

  // Module dependencies
  import {
    SvelteHead,
    FeatureHeroSection,
    LoggingSection,
    SyncSection,
    StatsSection,
    FeaturesSection,
    CallAction,
  } from '@centerhealth/fe/center-kit';
  import type { CtaModel } from '@centerhealth/fe/center-kit';
  import { page } from '$app/stores';

  // page info and meta
  const htmlHead = {
    title: 'Our App | Center Health',
    description:
      'Meet Center, an app for your diabetes combining simple logging, collaboration, and your very own personal assistant!',
    url: $page.url.href,
    host: $page.url.origin,
  };

  // call to action button on nav
  const cta: CtaModel = {
    label: 'Get started now 🎉',
    link: '/signup',
  };

  onMount(async () => {
    // A/B test cta to /subscribe
    const featuresCta = await AbTestService.getVariation('featureCta_22-08-24');
    if (featuresCta === 'linkSubscribe') {
      cta.link = '/subscribe';
    }
  });
</script>

<SvelteHead {htmlHead} />

<FeatureHeroSection />
<FeaturesSection flipComponent={true} />
<SyncSection />
<LoggingSection />
<StatsSection />
<CallAction
  {cta}
  title="Oh, and it's completely free!"
  subtitle="What do you say – ready to make a change?"
/>
